export default {
    page_title: "Kevi | Gestión de la Base de Clientes",
    title: "Gestión de la Base de Clientes",
    last_step_confirm: "Este es el último paso,",
    last_step_irreversible: "¡esta acción es irreversible!",
    start_deletion_text: "Para iniciar el proceso de eliminación parcial de su base de clientes,",
    click_here: "haz clic aquí",
    step1_title: "1. Establecer Filtros para la Eliminación de Clientes",
    apply_filters: "Aplicar Filtros",
    step2_title: "2. Confirmar Clientes y Leads a Eliminar",
    step3_title: "3. Confirmar y Eliminar Clientes",
    col_name: "Nombre",
    col_phone: "Teléfono",
    col_birthday: "Cumpleaños",
    col_avg_ticket: "Ticket Promedio ($)",
    col_total_spent: "$ Gastados",
    col_email: "E-mail",
    birthday_not_set: "No informado",
    details_button: "Detalles",
    clients_now: "Clientes ahora",
    selected_for_removal: "Seleccionados para eliminación",
    remaining_after_removal: "Clientes restantes tras la eliminación",
    delete_button_singular: "Eliminar {0} cliente",
    delete_button: "Eliminar {0} clientes",
    confirm_phrase_placeholder_singular: "Eliminar {0} cliente permanentemente",
    confirm_phrase_placeholder_plural: "Eliminar {0} clientes permanentemente",
    no_clients: "Aún no tienes ningún cliente registrado",
    total_stats: {
        title: "Total de la Base",
        clients: "Clientes",
        leads: "Leads",
        total: "Total (Clientes + Leads)",
    },
    clients_by_branch: {
        title: "Clientes por Unidad",
        clients_in: "Clientes en {0}",
    },
    deletion_info: {
        irreversible: "Eliminar clientes o leads de la base es una acción irreversible.",
        will_delete: "Junto con los clientes eliminaremos:",
        all_sales: "Todas sus ventas",
        all_tasks: "Todas sus tareas",
        all_messages: "Todos los mensajes enviados",
        all_records: "Cualquier registro vinculado a este cliente",
        permanent: "Esta eliminación es permanente.",
        inconsistency: "Eliminar parte de los clientes puede generar inconsistencia en los datos",
        inconsistency_detail: ", a partir del momento en que eliminas parte de tus clientes, es posible que los informes de Kevi ya no reflejen los mismos números que tu ERP.",
    },
};
